import React, { useEffect } from 'react'
import PropertyTypes from 'prop-types'
import useScript, { ScriptStatus } from '@charlietango/use-script'

const PyramidReport = ({ReportID, URL,...rest})=>{
    
    const fullUrlToJS = URL + "/no-shell/embed.js";
    const [ready, status] = useScript(fullUrlToJS) 
    useEffect(()=>{
        if (status === ScriptStatus.READY){
            window.pyramidInit()
            if (window.pyramidRunAll){
                window.pyramidRunAll()
            }
        }
    }, [ready])

    useEffect(()=>{
        if (window.pyramidRunAll){
            window.pyramidRunAll()
        }
    }, [])
   
    return (
        
        <React.Fragment>
            <div data-id={ReportID} data-type="discovery" className="pyramid-embed pyramid-auto" style={{width: "100%", height: "100%", position: "relative"}} data-host={URL} {...rest}></div>
        </React.Fragment> 
       
    )
}
PyramidReport.propTypes = {
    ReportID: PropertyTypes.string,
    URL: PropertyTypes.string
}
export default PyramidReport